<template>
  <v-container fluid class="pa-16 pt-8">
    <v-form ref="form" v-model="valid">
      <v-card
        v-if="allForm.partner_type !== 'Sponsor'"
        outlined
        class="px-6 py-2"
        elevation="1"
      >
        <v-row>
          <v-col cols="3" md="3" class="pt-4 pl-4">
            <label class="form-label-status"
              >Occupation <span class="error--text">* </span></label
            >
          </v-col>
          <v-col cols="9" md="9" class="input-col">
            <v-radio-group
              v-model="applicantForm.occupation"
              row
              dense
              :rules="[rules.required]"
              class="pt-0"
              hide-details="auto"
              :readonly="isReadOnly"
            >
              <v-radio label="Student" value="Student"></v-radio>
              <v-radio label="Unemployed" value="Unemployed"></v-radio>
              <v-radio label="Employed" value="Employed"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="applicantForm.occupation === 'Employed'"
            class="pl-4"
          >
            <label class="form-label-status"
              >Company Name <span class="error--text">* </span></label
            >
          </v-col>
          <v-col
            cols="12"
            md="9"
            v-if="applicantForm.occupation === 'Employed'"
          >
            <v-text-field
              v-model="applicantForm.company_name"
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
              :readonly="isReadOnly"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-card v-else outlined class="px-6 py-2" elevation="1">
        <v-row>
          <v-col cols="3" md="3" class="pt-4 pl-4">
            <label class="form-label-status"
              >Employee ID<span class="error--text">* </span></label
            >
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="applicantForm.employee_id"
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
              :readonly="isReadOnly"
            ></v-text-field>
          </v-col>
          <v-col cols="3" md="3" class="pt-4 pl-4">
            <label class="form-label-status"
              >Employee Email ID<span class="error--text">* </span></label
            >
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="applicantForm.employee_email_id"
              outlined
              dense
              :rules="[rules.required, rules.email]"
              hide-details="auto"
              :readonly="isReadOnly"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <label class="form-label-status"
              >ID Card Upload <span class="error--text">*</span></label
            >
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              v-model="applicantForm.id_card.file_name"
              class=""
              hint="ID Card Attached"
              persistent-hint
              dense
              readonly
              outlined
              @click="
                applicantForm.id_card.file_name
                  ? openDialog({
                      type: applicantForm.id_card.document_type,
                      file_binary: applicantForm.id_card.file_binary,
                    })
                  : ''
              "
              prepend-inner-icon="mdi-file-upload"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1" class="d-flex justify-center pl-0 ml-0 pb-5">
            <v-icon
              class="cursor-pointer"
              color="green"
              @click="$refs.idCardInput.click()"
              :disabled="isReadOnly"
            >
              mdi-upload
            </v-icon>
            <input
              type="file"
              ref="idCardInput"
              style="display: none"
              accept="application/pdf, image/png, image/jpeg, image/jpg"
              @change="onEmployeeFileReplaced($event, 'id_card', 'idCard')"
            />
          </v-col>
          <v-col cols="12" md="3">
            <label class="form-label-status" style="white-space: nowrap"
              >Full Time Employment Letter Upload
              <span class="error--text">*</span>
            </label>
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              v-model="applicantForm.employment_letter.file_name"
              class=""
              hint="ID Card Attached"
              persistent-hint
              dense
              readonly
              outlined
              @click="
                applicantForm.employment_letter.file_name
                  ? openDialog({
                      type: applicantForm.employment_letter.document_type,
                      file_binary: applicantForm.employment_letter.file_binary,
                    })
                  : ''
              "
              prepend-inner-icon="mdi-file-upload"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1" class="d-flex justify-center pl-0 ml-0 pb-5">
            <v-icon
              class="cursor-pointer"
              color="green"
              @click="$refs.employmentLetterInput.click()"
              :disabled="isReadOnly"
            >
              mdi-upload
            </v-icon>
            <input
              type="file"
              ref="employmentLetterInput"
              style="display: none"
              accept="application/pdf, image/png, image/jpeg, image/jpg"
              @change="
                onEmployeeFileReplaced(
                  $event,
                  'employment_letter',
                  'employmentLetter',
                )
              "
            />
          </v-col>
        </v-row>
      </v-card>
      <v-expansion-panels v-model="panels" multiple class="mt-3">
        <v-expansion-panel
          v-for="(edu, index) in educationForm"
          :key="index"
          :disabled="index > 0 && !isPreviousLevelComplete(index)"
        >
          <v-expansion-panel-header class="text-h6">
            {{ edu.qualification_name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="form-row mt-3">
              <v-col cols="12" md="3" class="text-left pt-2 pb-0 label-col">
                <label class="form-label"
                  >Name of Institution <span class="error--text">*</span></label
                >
              </v-col>
              <v-col cols="12" md="9" class="input-col">
                <v-text-field
                  v-model="edu.name_of_institution"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                  :readonly="isReadOnly"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="form-row">
              <v-col cols="12" md="3" class="text-left pt-2 label-col">
                <label class="form-label"
                  >Upload Marksheet <span class="error--text">*</span></label
                >
              </v-col>
              <v-col
                cols="12"
                :md="
                  index === educationForm.length - 1 &&
                  edu.qualification_order > 2
                    ? 6
                    : 8
                "
                class="input-col"
              >
                <v-text-field
                  v-model="edu.upload_image.file_name"
                  dense
                  readonly
                  outlined
                  hide-details
                  @click="
                    edu.upload_image.file_name
                      ? openDialog({
                          type: edu.upload_image.document_type,
                          file_binary: edu.upload_image.file_binary,
                        })
                      : ''
                  "
                ></v-text-field>
              </v-col>
              <!-- Upload Icon for Replace -->
              <v-col cols="12" md="1">
                <v-icon
                  class="cursor-pointer"
                  color="green"
                  @click="$refs.replaceFileInput[index].click()"
                  :disabled="isReadOnly"
                >
                  mdi-upload
                </v-icon>

                <!-- Hidden File Input for Replace -->
                <input
                  type="file"
                  ref="replaceFileInput"
                  :key="index"
                  style="display: none"
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                  @change="onFileReplaced($event, index)"
                />
              </v-col>
              <v-col
                v-if="
                  index === educationForm.length - 1 &&
                  edu.qualification_order > 2
                "
                cols="12"
                :md="
                  index === educationForm.length - 1 &&
                  edu.qualification_order > 2
                    ? 2
                    : 0
                "
                class="input-col"
              >
                <v-checkbox
                  v-model="applicantForm.completion_status"
                  class="mt-1"
                  density="compact"
                  :readonly="isReadOnly"
                  true-value="Awaiting Result"
                  false-value="Completed"
                  hide-details="auto"
                >
                  <template v-slot:label>
                    <span>Awaiting Result</span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row class="form-row" v-if="edu.qualification_order > 2">
              <v-col cols="12" md="3" class="text-left pt-2 label-col">
                <label class="form-label">
                  Upload Final/Provisional Certificate
                </label>
              </v-col>

              <v-col cols="12" md="8" class="input-col">
                <v-text-field
                  :value="edu.upload_certificate?.file_name"
                  persistent-hint
                  dense
                  readonly
                  outlined
                  @click="
                    edu.upload_certificate?.file_name
                      ? openDialog({
                          type: edu.upload_certificate.document_type,
                          file_binary: edu.upload_certificate.file_binary,
                        })
                      : ''
                  "
                  prepend-inner-icon="mdi-file-upload"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <v-icon
                  class="cursor-pointer"
                  color="green"
                  @click="triggerFileInput(index)"
                  :disabled="isReadOnly"
                >
                  mdi-upload
                </v-icon>

                <input
                  type="file"
                  :ref="'replaceFileInputCertificate_' + index"
                  style="display: none"
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                  @change="onFileCertificateReplaced($event, index)"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel v-if="showKovidaCard" key="kovida-panel">
          <v-expansion-panel-header class="text-h6">
            Kovida
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="3" md="3" class="pt-6 pl-4">
                <label class="form-label-status"
                  >Upload Certificate <span class="error--text">*</span></label
                >
              </v-col>
              <v-col cols="9" md="8">
                <v-text-field
                  v-model="applicantForm.kovida_certificate.file_name"
                  class=""
                  dense
                  readonly
                  outlined
                  @click="
                    applicantForm.kovida_certificate.file_name
                      ? openDialog({
                          type: applicantForm.kovida_certificate.document_type,
                          file_binary:
                            applicantForm.kovida_certificate.file_binary,
                        })
                      : ''
                  "
                  prepend-inner-icon="mdi-file-upload"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="1"
                class="d-flex justify-center pl-0 ml-0 pb-5"
              >
                <v-icon
                  class="cursor-pointer"
                  color="green"
                  @click="$refs.kovidaCertificateInput.click()"
                  :disabled="isReadOnly"
                >
                  mdi-upload
                </v-icon>
                <input
                  type="file"
                  ref="kovidaCertificateInput"
                  style="display: none"
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                  @change="
                    onEmployeeFileReplaced(
                      $event,
                      'kovida_certificate',
                      'kovidaCertificate',
                    )
                  "
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Submit and Reset Buttons -->
      <v-row v-if="!isReadOnly && !isAdmitted" class="form-row mt-6">
        <v-col cols="12" class="d-flex justify-end pr-0">
          <v-btn
            :disabled="
              JSON.stringify(this.originalFormValue) ===
                JSON.stringify(this.educationForm) &&
              JSON.stringify(this.applicantForm) ===
                JSON.stringify(this.copyApplicantForm)
            "
            color="success"
            class="mr-3"
            @click="submit"
          >
            Save and Next
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <attachmentViewer
      v-if="dialog"
      @closeDialog="dialog = false"
      :value="dialogData"
    />
  </v-container>
</template>

<script>
import attachmentViewer from "@/components/attachmentViewer.vue";
import { rules } from "@/helpers/rules";
import { cloneDeep } from "lodash";

export default {
  components: { attachmentViewer },
  data: () => ({
    rules,
    valid: false,
    panels: [0],
    form: [],
    educationForm: [],
    kovidaData: null,
    dialog: false,
    dialogData: {},
    applicantForm: {},
    copyApplicantForm: {},
    originalFormValue: [],
  }),
  props: {
    value: {
      type: Array,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    allForm: {
      type: Object,
      required: true,
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.form = cloneDeep(newVal);
        this.separateKovidaFromForm();
        this.formApplicantForm();
        this.originalFormValue = cloneDeep(this.form);
        this.$emit("validate", true);
      },
      deep: true,
    },
    valid(newValue) {
      if (!newValue) return this.$emit("validate", false);

      this.$emit(
        "validate",
        JSON.stringify(this.originalFormValue) === JSON.stringify(this.form) &&
          JSON.stringify(this.applicantForm) ===
            JSON.stringify(this.copyApplicantForm),
      );

      const lastPanel = Math.max(...this.panels);
      const prev = this.educationForm[lastPanel];

      const isFilled = prev?.name_of_institution && prev?.upload_image;

      const nextPanel = lastPanel + 1;

      if (
        isFilled &&
        nextPanel < this.educationForm.length &&
        !this.panels.includes(nextPanel)
      ) {
        this.panels.push(nextPanel);
      }
    },
    applicantForm: {
      handler(newVal) {
        if (
          !this.valid ||
          JSON.stringify(this.copyApplicantForm) !== JSON.stringify(newVal)
        ) {
          this.$emit("validate", false);
        } else {
          this.$emit("validate", true);
        }
      },
      deep: true,
    },
    form: {
      handler(newVal) {
        if (
          !this.valid ||
          JSON.stringify(this.originalFormValue) !== JSON.stringify(newVal)
        ) {
          this.$emit("validate", false);
        } else {
          this.$emit("validate", true);
        }
      },
      deep: true,
    },
  },
  computed: {
    isAdmitted() {
      return (
        (this.allForm.application_status || "").toString().toLowerCase() ===
        "admitted"
      );
    },
    showKovidaCard() {
      return this.kovidaData !== null || this.allForm.program_id == 5;
    },
    isAllEducationComplete() {
      // Check if all education panels are completed
      if (this.educationForm.length === 0) return true;
      return this.educationForm.every((edu) => {
        return edu.name_of_institution && edu.upload_image;
      });
    },
    isPreviousLevelComplete() {
      return (index) => {
        if (index === 0) return true;
        const previous = this.educationForm[index - 1];

        return previous.name_of_institution && previous.upload_image;
      };
    },
  },
  created() {
    this.form = cloneDeep(this.value);
    this.separateKovidaFromForm();
    this.formApplicantForm();
    this.originalFormValue = cloneDeep(this.form);
    this.$nextTick(() => {
      this.educationForm.map((item, index) => {
        if (item.name_of_institution) {
          this.panels.push(index);
        }
      });
      // Auto-expand Kovida panel if it exists
      if (this.showKovidaCard && this.isAllEducationComplete) {
        this.panels.push(this.educationForm.length);
      }
    });
  },
  methods: {
    separateKovidaFromForm() {
      // Find Kovida object
      const kovidaIndex = this.form.findIndex(
        (item) => item.qualification_name === "Kovida",
      );

      if (kovidaIndex !== -1) {
        // Store Kovida data
        this.kovidaData = this.form[kovidaIndex];
        // Remove Kovida from form array
        this.educationForm = this.form.filter(
          (item) => item.qualification_name !== "Kovida",
        );

        // Update applicantForm with Kovida data if exists
        if (this.kovidaData.upload_image && this.kovidaData.upload_image.id) {
          this.applicantForm.kovida_certificate = this.kovidaData.upload_image;
        } else if (
          this.kovidaData.upload_image &&
          this.kovidaData.upload_image.file_name
        ) {
          this.applicantForm.kovida_certificate = this.kovidaData.upload_image;
        }
      } else {
        this.educationForm = cloneDeep(this.form);
        this.kovidaData = null;
      }
    },
    onFileReplaced(event, index) {
      const file = event.target.files[0];
      if (!file) return;

      // Replace the existing upload_image object
      const reader = new FileReader();
      reader.onload = (e) => {
        const [type, _] = file.type.split("/");
        const result = e.target.result;
        const base64 = result.split(",")[1];
        this.educationForm[index].upload_image = {
          file_name: file.name,
          file_binary: base64,
          document_type: type,
        };
      };
      reader.readAsDataURL(file);
      this.educationForm[index].newUploadImage = file;
    },

    triggerFileInput(index) {
      const el = this.$refs[`replaceFileInputCertificate_${index}`];
      if (el && el[0]) {
        el[0].click();
      } else if (el) {
        el.click();
      } else {
        console.warn(`Ref not found for index: ${index}`);
      }
    },
    onFileCertificateReplaced(event, index) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const [type, _] = file.type.split("/");
        const result = e.target.result;
        const base64 = result.split(",")[1];
        this.educationForm[index].upload_certificate = {
          file_name: file.name,
          file_binary: base64,
          document_type: type,
        };
      };
      reader.readAsDataURL(file);
      this.educationForm[index].newUploadCertificate = file;
    },
    getPlaceholder(type) {
      return type === "marks"
        ? "Enter Marks"
        : type === "grade"
        ? "Enter Grade"
        : "Enter CGPA";
    },
    openDialog(data) {
      this.dialogData = data;
      this.dialog = true;
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      // Merge educationForm and Kovida data back for submission
      const finalForm = [...this.educationForm];
      if (this.kovidaData !== null) {
        const kovidaEntry = {
          ...this.kovidaData,
          upload_image: this.applicantForm.kovida_certificate,
          name_of_institution: "Kovida",
          qualification_name: "Kovida",
        };
        finalForm.push(kovidaEntry);
      } else if (
        this.allForm.program_id == 5 &&
        this.applicantForm.kovida_certificate?.file_name
      ) {
        const kovidaEntry = {
          name_of_institution: "Kovida",
          qualification_name: "Kovida",
          qualification_order: 99,
          upload_image: this.applicantForm.kovida_certificate,
          upload_certificate: null,
          is_attached: true,
          is_attached_certificate: false,
          id: null,
          completion_status: "Completed",
        };
        finalForm.push(kovidaEntry);
      }
      this.$emit("submit", finalForm, this.applicantForm);
    },

    validatePair(index) {
      this.$nextTick(() => {
        const marksRef = this.$refs["marks_"]?.[index];
        const totalRef = this.$refs["total_"]?.[index];

        if (marksRef && marksRef.validate) marksRef.validate();
        if (totalRef && totalRef.validate) totalRef.validate();
      });
    },
    onEmployeeFileReplaced(event, value, newValue) {
      const file = event.target.files[0];
      if (!file) return;

      // Replace the existing upload_image object
      const reader = new FileReader();
      reader.onload = (e) => {
        const [type, _] = file.type.split("/");
        const result = e.target.result;
        const base64 = result.split(",")[1];
        this.applicantForm[value] = {
          file_name: file.name,
          file_binary: base64,
          document_type: type,
        };
      };
      reader.readAsDataURL(file);
      this.applicantForm[newValue] = file;
    },
    formApplicantForm() {
      const {
        completion_status,
        occupation,
        company_name,
        employee_id,
        id_card,
        employment_letter,
        is_employment_letter_attached,
        is_id_card_attached,
        employee_email_id,
        kovida_certificate,
        is_kovida_certificate_attached,
      } = this.allForm;
      this.applicantForm = {
        completion_status,
        occupation,
        company_name,
        employee_id,
        id_card,
        employment_letter,
        is_employment_letter_attached,
        is_id_card_attached,
        employee_email_id,
        kovida_certificate: kovida_certificate || { file_name: null },
        is_kovida_certificate_attached: is_kovida_certificate_attached || false,
        kovidaCertificate: null,
      };
      this.copyApplicantForm = JSON.parse(JSON.stringify(this.applicantForm));
    },
  },
};
</script>

<style scoped>
.input-col {
  padding-top: 0;
}

.form-label {
  font-weight: 600;
}

.form-label-status {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}
.disabled-label {
  color: #bdbdbd;
}
::v-deep(.v-messages) {
  color: green !important;
}
.dialog-card {
  border-radius: 16px;
  overflow: hidden;
}

.attachment-image {
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: contain;
}

.attachment-iframe {
  width: 100%;
  height: 500px;
  border-radius: 8px;
}
</style>
